import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import { Section, SectionInner, SectionHeading, Mark } from "../../globalStyles";

const Split = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 5fr) minmax(0, 7fr);
  gap: var(--space-12);
  align-items: start;

  @media screen and (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: var(--space-6);
  }
`;

const Body = styled.div`
  max-width: 36rem;
`;

const Lead = styled.p`
  font-size: 1.0625rem;
  line-height: 1.75;
  color: var(--text-secondary);
  word-break: keep-all;
  text-wrap: pretty;

  & + & {
    margin-top: var(--space-4);
  }

  & b {
    color: var(--text-primary);
    font-weight: var(--font-weight-semibold);
  }

  @media screen and (max-width: 768px) {
    font-size: var(--font-size-base);
  }
`;

const TeamSection = () => {
  const [language, setLanguage] = useState("ko");
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/en") setLanguage("en");
    else if (location.pathname === "/ko") setLanguage("ko");
    else setLanguage(localStorage.getItem("language") || "ko");

    const handleLanguageChange = (e) => setLanguage(e.detail);
    window.addEventListener("languageChange", handleLanguageChange);
    return () =>
      window.removeEventListener("languageChange", handleLanguageChange);
  }, [location.pathname]);

  const content = {
    ko: {
      heading: ["업계 내 ", "최고 수준", "의 팀원 구성"],
      leads: [
        "능력있고 배울 점이 있는 팀원들에게 둘러싸여 <b>즐겁게 일할 수 있는 환경</b>을 만들어왔습니다.",
        "팀 평균 나이는 20대로, 젊고 뛰어난 사람들이 모여 있으며 앞으로도 <b>높은 기준</b>을 가지고 이 강점을 지켜갈 계획입니다.",
      ],
    },
    en: {
      heading: ["A team at the ", "top of the industry", ""],
      leads: [
        "We've built an environment where you can <b>enjoy your work</b>, surrounded by talented people you can learn from.",
        "The team's average age is in its 20s. Young, exceptional people, and we plan to keep this strength with a <b>high bar</b> going forward.",
      ],
    },
  };

  const c = content[language];

  return (
    <Section $rule>
      <SectionInner>
        <Split>
          <SectionHeading>
            {c.heading[0]}
            <Mark>{c.heading[1]}</Mark>
            {c.heading[2]}
          </SectionHeading>
          <Body>
            {c.leads.map((l, i) => (
              <Lead key={i} dangerouslySetInnerHTML={{ __html: l }} />
            ))}
          </Body>
        </Split>
      </SectionInner>
    </Section>
  );
};

export default TeamSection;
